import { Link } from 'react-router-dom';
import { useApiQuery } from '../../hooks/useApiQuery';
import { OrderSummary } from '../../types/orders';
import { formatDate, humanize, money, shortId } from '../../lib/format';
export default function OrdersPage() {
  const { data, error, loading } = useApiQuery<OrderSummary[]>('/orders');
  const orders = data ?? [];
  return (
    <section className="page-container account-page">
      <h1>Your orders</h1>
      {error && <p role="alert">{error}</p>}
      {loading && <p role="status">Loading orders…</p>}
      {!loading && !error && !orders.length && <p>No orders yet.</p>}
      {orders.map((o) => (
        <article key={o.id}>
          <Link to={`/orders/${o.id}`}>Order {shortId(o.id)}</Link>
          <p>
            {formatDate(o.created_at)} · {humanize(o.status)} · {money(o.amount_paise)}
          </p>
        </article>
      ))}
    </section>
  );
}
